import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_branch_settlement_method_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    settlement_code: fromDatatype.VarcharArrayDatatypeInterface;
    sort_code: fromDatatype.VarcharArrayDatatypeInterface;
    branch_code: fromDatatype.VarcharArrayDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: fromDatatype.VarcharArrayDatatypeInterface;
    processed: fromDatatype.VarcharArrayDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: any;
    acl_policy: any;
    acl_config: any;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharArrayDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
}

export class bl_fi_mst_branch_settlement_method_import_file_helper_RowClass implements bl_fi_mst_branch_settlement_method_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    settlement_code: fromDatatype.VarcharArrayDatatypeInterface;
    sort_code: fromDatatype.VarcharArrayDatatypeInterface;
    branch_code: fromDatatype.VarcharArrayDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: fromDatatype.VarcharArrayDatatypeInterface;
    processed: fromDatatype.VarcharArrayDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: any;
    acl_policy: any;
    acl_config: any;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharArrayDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
}